export enum ApprovalState {
    Submitted = 'Submitted',
    Draft = 'Draft'
}